module.exports = __webpack_public_path__ + "img/icon_map_5_on_100.9f3705ad.png";